import { API, get } from "../../config";

/**  
 * * Start: Vendor Detail API
 * @param {String} vendorId (Vendor uuid)
 * @return {JSON}  Vendor Record data of that id
**/
export const getVendorDetail = async (vendorId) => {
  try {
    const { data } = await get(`${API.VENDOR_DETAILS}/` + vendorId);
    return data.data;
  } catch (e) {
    return null;
  }
};

// * End: Vendor Detail API
